import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { HelpHint } from "@/components/HelpHint";

// Student Detail -> "Edit Student" dialog (staff only). Extracted from
// StudentDetail.js (props-driven, no behavior change).
export const EditStudentDialog = ({ open, onOpenChange, form, onFormChange, meetingLocationOptions, instructors, onSave }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg" data-testid="edit-student-dialog">
      <DialogHeader>
        <DialogTitle>Edit Student</DialogTitle>
      </DialogHeader>
      <div className="grid sm:grid-cols-2 gap-3 max-h-[60vh] overflow-y-auto pr-1">
        <div className="space-y-1.5 sm:col-span-2">
          <Label>Full name</Label>
          <Input value={form.full_name || ""} onChange={(e) => onFormChange((f) => ({ ...f, full_name: e.target.value }))} data-testid="edit-student-name-input" />
        </div>
        <div className="space-y-1.5">
          <Label>Phone</Label>
          <Input value={form.phone || ""} onChange={(e) => onFormChange((f) => ({ ...f, phone: e.target.value }))} />
        </div>
        <div className="space-y-1.5">
          <Label>Status</Label>
          <select className="w-full h-11 rounded-[var(--radius)] border bg-background px-3 text-sm" value={form.status || "active"} onChange={(e) => onFormChange((f) => ({ ...f, status: e.target.value }))}>
            <option value="active">Active</option>
            <option value="completed">Completed</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
        <div className="space-y-1.5 sm:col-span-2">
          <Label>Navigation address</Label>
          <Input value={form.navigation_address || ""} onChange={(e) => onFormChange((f) => ({ ...f, navigation_address: e.target.value }))} />
        </div>
        <div className="space-y-1.5">
          <Label className="flex items-center gap-1.5">
            Classroom hours completed
            <HelpHint text="Manually tracked for now — logged here by office staff until classroom attendance is automated." testId="classroom-hours-help" />
          </Label>
          <Input type="number" min={0} step="0.5" value={form.classroom_hours_completed ?? 0}
            onChange={(e) => onFormChange((f) => ({ ...f, classroom_hours_completed: e.target.value }))}
            data-testid="edit-student-classroom-hours-input" />
        </div>
        <div className="space-y-1.5">
          <Label className="flex items-center gap-1.5">
            Observation hours completed
            <HelpHint text="Manually tracked for now — logged here by office staff until observation hours are automated." testId="observation-hours-help" />
          </Label>
          <Input type="number" min={0} step="0.5" value={form.observation_hours_completed ?? 0}
            onChange={(e) => onFormChange((f) => ({ ...f, observation_hours_completed: e.target.value }))}
            data-testid="edit-student-observation-hours-input" />
        </div>
        <div className="space-y-1.5 sm:col-span-2">
          <Label>Default meeting location</Label>
          <select className="w-full h-11 rounded-[var(--radius)] border bg-background px-3 text-sm" value={form.default_meeting_location || ""} onChange={(e) => onFormChange((f) => ({ ...f, default_meeting_location: e.target.value }))} data-testid="edit-student-meeting-location-select">
            <option value="">Not set</option>
            {meetingLocationOptions.map((l) => (
              <option key={l.id} value={l.name}>{l.name}</option>
            ))}
          </select>
        </div>
        <div className="space-y-1.5 sm:col-span-2">
          <Label>Assigned instructor</Label>
          <select className="w-full h-11 rounded-[var(--radius)] border bg-background px-3 text-sm" value={form.assigned_instructor_id || ""} onChange={(e) => onFormChange((f) => ({ ...f, assigned_instructor_id: e.target.value }))} data-testid="edit-student-instructor-select">
            <option value="">Unassigned</option>
            {instructors.map((i) => (
              <option key={i.id} value={i.id}>{i.full_name}</option>
            ))}
          </select>
        </div>
      </div>
      <DialogFooter>
        <Button onClick={onSave} data-testid="edit-student-save-button">Save Changes</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
